import React, { useState } from 'react';

const CateringOffers = () => {
    const [formData, setFormData] = useState({
        type: '',
        description: '',
        goal: '',
        startDate: '',
        endDate: '',
        discount: '',
    });

    const [couponRequests, setCouponRequests] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const isMobile = window.innerWidth <= 768;

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const newRequest = {
            ...formData,
            status: 'Pending',
            submittedOn: new Date().toLocaleDateString(),
        };
        setCouponRequests([...couponRequests, newRequest]);
        setFormData({
            type: '',
            description: '',
            goal: '',
            startDate: '',
            endDate: '',
            discount: '',
        });
        setShowModal(false);
    };

    return (
        <div
            style={{
                padding: '20px',
                maxWidth: '1200px',
                margin: isMobile ? '38px 0 0 -125px' : '38px auto',
                boxSizing: 'border-box',
                position: 'relative',
                width: '100%',
            }}
        >
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '20px'
            }}>
                <button
                    style={{
                        padding: '10px 16px',
                        backgroundColor: '#1976d2',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        fontSize: 'clamp(12px, 2vw, 14px)',
                    }}
                    onClick={() => setShowModal(true)}
                >
                    + Add Offers
                </button>
            </div>

            {/* Table Section */}
            <div style={{
                marginTop: '-30px',
                overflowX: 'auto',
                width: '100%'
            }}>
                <div style={{
                    minWidth: '800px',
                    width: '100%'
                }}>
                    <table
                        style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            backgroundColor: 'white',
                            border: '1px solid #ccc',
                        }}
                    >
                        <thead>
                            <tr>
                                {[
                                    'S.No',
                                    'Type',
                                    'Description',
                                    'Goal',
                                    'Start Date',
                                    'End Date',
                                    'Discount',
                                    'Status',
                                    'Submitted On',
                                ].map((head, i) => (
                                    <th
                                        key={i}
                                        style={{
                                            border: '1px solid #ccc',
                                            padding: '10px',
                                            backgroundColor: '#b15cd6',
                                            fontSize: 'clamp(10px, 2vw, 14px)',
                                            textAlign: 'left',
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        {head}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {couponRequests.length === 0 ? (
                                <tr>
                                    <td colSpan="9" style={{ textAlign: 'center', padding: '12px' }}>
                                        No requests yet.
                                    </td>
                                </tr>
                            ) : (
                                couponRequests.map((request, index) => (
                                    <tr key={index}>
                                        <td style={{ ...tdStyle, fontSize: 'clamp(10px, 2vw, 14px)' }}>{index + 1}</td>
                                        <td style={{ ...tdStyle, fontSize: 'clamp(10px, 2vw, 14px)' }}>{request.type}</td>
                                        <td style={{ ...tdStyle, fontSize: 'clamp(10px, 2vw, 14px)' }}>{request.description}</td>
                                        <td style={{ ...tdStyle, fontSize: 'clamp(10px, 2vw, 14px)' }}>{request.goal}</td>
                                        <td style={{ ...tdStyle, fontSize: 'clamp(10px, 2vw, 14px)' }}>{request.startDate}</td>
                                        <td style={{ ...tdStyle, fontSize: 'clamp(10px, 2vw, 14px)' }}>{request.endDate}</td>
                                        <td style={{ ...tdStyle, fontSize: 'clamp(10px, 2vw, 14px)' }}>{request.discount}%</td>
                                        <td style={{ ...tdStyle, fontSize: 'clamp(10px, 2vw, 14px)' }}>{request.status}</td>
                                        <td style={{ ...tdStyle, fontSize: 'clamp(10px, 2vw, 14px)' }}>{request.submittedOn}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Modal Popup */}
            {showModal && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        height: '100vh',
                        width: '100vw',
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1000,
                    }}
                >
                    <div
                        style={{
                            backgroundColor: '#fff',
                            padding: '20px',
                            borderRadius: '10px',
                            width: '90%',
                            maxWidth: '600px',
                            maxHeight: '90vh',
                            overflowY: 'auto',
                            boxSizing: 'border-box',
                        }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h3 style={{ fontSize: 'clamp(16px, 3vw, 20px)', fontWeight: 'bold' }}>Request a Coupon</h3>
                            <button
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    fontSize: '18px',
                                    cursor: 'pointer',
                                }}
                                onClick={() => setShowModal(false)}
                            >
                                ✕
                            </button>
                        </div>

                        <form onSubmit={handleSubmit} style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '12px',
                            marginTop: '16px'
                        }}>
                            <input
                                type="text"
                                name="type"
                                placeholder="Coupon Type"
                                value={formData.type}
                                onChange={handleChange}
                                required
                                style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
                            />
                            <textarea
                                name="description"
                                placeholder="Description"
                                value={formData.description}
                                onChange={handleChange}
                                rows="3"
                                required
                                style={{ ...inputStyle, resize: 'vertical', fontSize: 'clamp(12px, 2vw, 14px)' }}
                            />
                            <input
                                type="text"
                                name="goal"
                                placeholder="Goal (e.g., Increase Leads)"
                                value={formData.goal}
                                onChange={handleChange}
                                required
                                style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
                            />

                            <div style={{
                                display: 'flex',
                                flexDirection: window.innerWidth < 480 ? 'column' : 'row',
                                gap: '12px'
                            }}>
                                <div style={{ flex: 1 }}>
                                    <label style={labelStyle}>
                                        Start Date
                                        <input
                                            type="date"
                                            name="startDate"
                                            value={formData.startDate}
                                            onChange={handleChange}
                                            required
                                            style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
                                        />
                                    </label>
                                </div>
                                <div style={{ flex: 1 }}>
                                    <label style={labelStyle}>
                                        End Date
                                        <input
                                            type="date"
                                            name="endDate"
                                            value={formData.endDate}
                                            onChange={handleChange}
                                            required
                                            style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
                                        />
                                    </label>
                                </div>
                            </div>

                            <input
                                type="number"
                                name="discount"
                                placeholder="Discount (%)"
                                value={formData.discount}
                                onChange={handleChange}
                                required
                                style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
                            />

                            <button
                                type="submit"
                                style={{
                                    padding: '12px',
                                    backgroundColor: '#1976d2',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    width: 'fit-content',
                                    fontSize: 'clamp(12px, 2vw, 14px)'
                                }}
                            >
                                Submit Request
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

// Reusable styles
const inputStyle = {
    padding: '10px',
    border: '1px solid #ccc',
    borderRadius: '6px',
    width: '100%',
    boxSizing: 'border-box',
};

const labelStyle = {
    fontSize: 'clamp(12px, 2vw, 14px)',
    marginBottom: '4px',
    display: 'block',
};

const tdStyle = {
    padding: '10px',
    border: '1px solid #ccc',
    textAlign: 'left',
};

export default CateringOffers;